import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-section">
          <h2>Contacto</h2>
          <p><a href="mailto:info@cmsoltec.com">info@cmsoltec.com</a></p>
          <p><a href="tel:+593984813777">(+593) 98 481 3777</a></p>
        </div>

        <div className="footer-section">
          <h2>Navegación</h2>
          <ul>
            <li><a href="/">Inicio</a></li>
            <li><a href="/acerca-de-nosotros">Nosotros</a></li>
            <li><a href="/servicios">Servicios</a></li>
            <li><a href="/categorias">Tienda</a></li>
            <li><a href="/contacto">Contacto</a></li>
            <li><a href="/terminos-condiciones">Términos y Condiciones</a></li>
            <li><a href="/politicas-privacidad">Política de Privacidad</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h2>Síguenos</h2>
          <div className="social-icons">
            <a href="https://www.facebook.com/cmsoltec/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/cmsoltec/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@cmsoltec?lang=es" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>

      <hr className="footer-divider" />

      <p className="footer-rights">
        © 2025 CM SOLUTION AND TECHNOLOGY. Todos los derechos reservados. Desarrollado por&nbsp;
        <a href="https://devzone.ec" target="_blank" rel="noopener noreferrer">DEVZONE</a>
      </p>
    </footer>
  );
};

export default Footer;
